import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);

export class Utils {
  // convert longitude/latitude into decimal 
  static geoCoordValue(degree: number, min: number, sec: number, ref: string): number {
    const result = degree + (min / 60) + (sec / 3600);
    //console.log(`${degree} + (${min}/60) + (${sec}/3600) [ref:${ref}]`);
    const isNorthOrEast = ref === 'N' || ref === 'E';
    // latitude: if N -> +
    // longitude: if E -> +
    return isNorthOrEast ? Number(result.toFixed(6)) : Number(-result.toFixed(6));
  }

  static metaDateToIsoString = (exifDateStr: string): string => {
    const [datePart, timePart] = exifDateStr.split(" ");
    const formattedDate = datePart.replaceAll(":", "-");
    return `${formattedDate}T${timePart}.000Z`;
  };

  // Assumes date is in UTC and converts it to local timezone
  static formatDate = (date: Date|string, omitTime?: boolean): string => {
    let format = "DD MMM YYYY, hh:mm:ss A";
    if (omitTime) {
      format = "DD MMM YYYY";
    }
    return dayjs.utc(date).tz(dayjs.tz.guess()).format(format);
  };
}